import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './login/auth.guard';
import {LoginComponent} from './login/login.component';
import {MainComponent} from './main/main.component';
import {MicrositeComponent} from './microsite/microsite.component';


const appRoutes: Routes = [
    { path: '', component: LoginComponent},
    { path: 'login', component: LoginComponent },
    { path: 'microsite', component: MicrositeComponent },
    { path: '**', redirectTo: 'login' },
    { path: 'main',component: MainComponent, canActivate: [AuthGuard]}
];

export const routing: ModuleWithProviders = RouterModule.forRoot(appRoutes);
